import { useCallback, useEffect } from 'react';
import useDialog from '@/components/organisms/useDialog';
import { CustomEvents } from '@/libs/eventBus/constants';
import EventBus from '@/libs/eventBus/eventBus';

export const useHighlightReelPopover = () => {
  const { isOpen: isHighlightReelPopoverOpen, openDialog, closeDialog } = useDialog();

  const toggleHighlightReelPopover = useCallback(
    ({ isOpen }: { isOpen: boolean }) => {
      if (isOpen) {
        openDialog();
        return;
      }
      closeDialog();
    },
    [openDialog, closeDialog]
  );

  useEffect(() => {
    const eventListener = EventBus.on(CustomEvents.HighlightListPopUp, toggleHighlightReelPopover);
    return () => {
      EventBus.off(CustomEvents.HighlightListPopUp, eventListener);
    };
  }, [toggleHighlightReelPopover]);

  return {
    isHighlightReelPopoverOpen,
    closeDialog
  };
};
